import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { solarizedlight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { fetchTeamJobDetail, IJob } from '../../../services/stixify_api.ts';
import { URLS } from '../../../services/urls.ts';
import { Link, useParams } from 'react-router-dom';
import { TeamRouteContext } from '../../team-layout.tsx/index.tsx';
import { getDateString } from '../../../services/utils.ts';


const JobDetailsComponent = () => {
    const [job, setJob] = useState<IJob>()
    const { id } = useParams<{ id: string }>();
    const { teamId } = useContext(TeamRouteContext)
    const [loading, setLoading] = useState(false)


    const loadJob = async (id: string) => {
        setLoading(true);
        try {
            const response = await fetchTeamJobDetail(teamId, id);
            setJob(response.data);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        document.title = 'Job Detail | Stixify Web'
    }, [])

    useEffect(() => {
        if(!id) return
        loadJob(id);
    }, [teamId, id]);


    const getReportDetailPage = () => {
      if(!job) return ''
      if(!teamId) return URLS.staffReportDetail(job.report)
      return URLS.teamReportDetail(teamId, job.report)
    }

    return <Box p={4}>
        <Typography variant='h4'>Report Job ID: {job?.id}</Typography>
        <Typography sx={{ marginTop: '1rem' }}>
            <b>Run datetime:</b> {getDateString(job?.run_datetime)}
        </Typography>
        <Typography>
            <b>State:</b> {job?.state}
        </Typography>
        <Link to={getReportDetailPage()} style={{ textDecoration: 'none' }}>
            <Typography>View Report</Typography>
        </Link>
        <Box mt={4}>
          <Typography variant="h5">Report Metadata</Typography>
          <SyntaxHighlighter language="json" style={solarizedlight}>
            {JSON.stringify(job?.metadata, null, 2)}
          </SyntaxHighlighter>
        </Box>
    </Box>
}

export default JobDetailsComponent